import showAlert from './showAlert'; 

export default async function () {
	const validResponses = ['RU', 'BY'];

	try {
		const response = await fetch('https://api.verv.com/v4/split/geo');
		const data = await response.json();
		if (validResponses.includes(data.country_code)) {
			showAlert();
			// return true;
		} else {
			// return false;
		}
	} catch (error) {
		// return false;
	}
}
